if (!customElements.get('media-card')) {
  customElements.define('media-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-sound-toggle]');
      if (!video || !button) return;
      video.muted = true;
      const update = () => {
        button.setAttribute('aria-label', video.muted ? this.dataset.unmute : this.dataset.mute);
        button.querySelector('[data-muted-icon]').toggleAttribute('hidden', !video.muted);
        button.querySelector('[data-audible-icon]').toggleAttribute('hidden', video.muted);
      };
      button.addEventListener('click', () => {
        video.muted = !video.muted;
        if (video.paused) video.play().catch(() => {});
      }, { signal });
      video.addEventListener('volumechange', update, { signal });
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = () => {
        video.autoplay = !motion.matches;
        if (motion.matches) video.pause();
      };
      motion.addEventListener('change', autoplay, { signal });
      autoplay();
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !motion.matches) video.play().catch(() => {});
        else video.pause();
      });
      this.observer.observe(this);
      update();
      button.hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
